// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"111":"9a30be8d","241":"449c8234","263":"f5b9f029","331":"939df748","952":"50738642"}[chunkId] + ".chunk.js";
};